module.exports = __webpack_public_path__ + "img/r-117.ac3ab0b1.jpg";